import axios from 'axios'

/**
 * Removes a list of miners from a container
 *
 * @param id container ID.
 * @param minerIDs the list of miner IDs to remove.
 */
export async function removeMinersFromContainer(id: number, minerIDs: number[]) {
  const res = await axios.delete(`${import.meta.env.VITE_APP_RC_CONTAINERS_ENDPOINT}/${id}/miners`, {
    data: { miner_ids: minerIDs },
  })
  return res.data
}

/**
 * Removes a list of miners from a container
 *
 * @param originContainerID origin container ID.
 * @param destinationContainerID origin container ID.
 * @param minerIDs the list of miner IDs to remove.
 */
export async function moveMinersBetweenContainers(
  originContainerID: number,
  destinationContainerID: number,
  minerIDs: number[]
) {
  const res = await axios.post(`${import.meta.env.VITE_APP_RC_CONTAINERS_ENDPOINT}/miners/arrange`, {
    origin_container_id: originContainerID,
    destination_container_id: destinationContainerID,
    miner_ids: minerIDs,
  })
  return res.data
}

/**
 * Adds a list of miners to a container
 *
 * @param id container ID.
 * @param minerIDs the list of miner IDs to add.
 */
export async function assignMinersToContainer(id: number, minerIDs: number[]) {
  const res = await axios.post(`${import.meta.env.VITE_APP_RC_CONTAINERS_ENDPOINT}/${id}/miners`, {
    miner_ids: minerIDs,
  })
  return res.data
}
